<div class="header">
  <div id="title-wrapper">
    <i i-bs id="back-button" name="arrow-left-short" class="icon-btn" width="30" height="30" aria-label="Retour" (click)="onBack.emit()"></i>
    <h3 id="title-text">{{patientGroup?.name}}</h3>
  </div>
  <button id="edit-button" (click)="onEdit.emit()" type="button"
    class="btn btn-primary btn-gradient icon-only" dropdownToggle>
    <i i-bs name="pencil" width="15" height="15"></i>
  </button>
</div>
<div *ngIf="!error && !isLoading && patients && patients.length > 0; else innerLoading"
  id="patient-list">
  <msd-patient-cell *ngFor="let p of patients" [name]="p.fullName" [initials]="p.initials" [pictureUrl]="p.avatarUrl" [archived]="p.archived"></msd-patient-cell>
</div>

<ng-template #innerLoading>
  <ngx-inner-loading class="flex-center" [empty]="patients?.length === 0" [error]="!!error"
    [loading]="isLoading" (retry)="loadPatientGroupPatients()" [loadingDescription]="'Chargement...'"
    [emptyDescription]="'Aucun patient'"
    [errorDescription]="error" [retryButtonText]="'Réessayer'">
  </ngx-inner-loading>
</ng-template>
